import React from 'react';
import { INavigationItemProps } from '../constants/interfaces';

export type IAppBarItemsProps = INavigationItemProps[][] | [];

export interface IAppBarContext {
    methods: {
        setAppBarItems: (appBarItems: IAppBarItemsProps) => void;
    };
    state: {
        appBarItems: IAppBarItemsProps;
    };
}

export const useAppBarContext = () => {
    const value = React.useContext(AppBarContext);

    if (value?.state?.appBarItems === undefined) {
        throw new Error(
            'useAppBarContext must be used within AppBarContextProvider',
        );
    }

    return value;
};

const AppBarContext = React.createContext<Partial<IAppBarContext>>({});

const AppBarContextProvider = ({ children }: any) => {
    const [appBarItems, setAppBarItems] = React.useState<IAppBarItemsProps>([
        [],
    ]);

    const exportedValues: IAppBarContext = {
        methods: {
            setAppBarItems,
        },
        state: {
            appBarItems,
        },
    };

    return (
        <AppBarContext.Provider value={exportedValues}>
            {children}
        </AppBarContext.Provider>
    );
};

export default {
    Context: AppBarContext,
    Consumer: AppBarContext.Consumer,
    Provider: AppBarContextProvider,
};
